import {compareByPosition, SORT_UP, sortWithDirection} from "../../utils/Array.extensions";
import {ColumnWithOrdering} from "./ColumnWithOrdering";
import {BUSINESS_UNIT_COLUMN} from "./columns";

/**
 * This class responsibility is to manage the ordering of a
 * set of Dashboard items for different columns.
 */
export class DashboardItemsOrdering {
    constructor() {
        this._orderingValuesPerItem = {}
    }

    // public

    static defaultOrdering() {
        return new ColumnWithOrdering(BUSINESS_UNIT_COLUMN, SORT_UP);
    }

    addOrderingValues(itemId, columnName, listOfValues) {
        if (!(itemId in this._orderingValuesPerItem)) {
            this._orderingValuesPerItem[itemId] = {}
        }

        this._orderingValuesPerItem[itemId] = {
            ...this._orderingValuesPerItem[itemId],
            [columnName]: listOfValues
        };
    }

    sortByColumn(dashboardItems, columnOrdering) {
        const columnName = columnOrdering.columnId();
        const orderingDirection = columnOrdering.orderingDirection();

        return sortWithDirection(dashboardItems, (anItem, anotherItem) => {
            const anItemOrderingValues = this._orderingValuesFor(anItem.id, columnName);
            const anotherItemOrderingValues = this._orderingValuesFor(anotherItem.id, columnName);

            return compareByPosition(anItemOrderingValues, anotherItemOrderingValues);
        }, orderingDirection);
    }

    // private

    _orderingValuesFor(dashboardItemId, columnName) {
        const listWithMinValue = [Number.MIN_SAFE_INTEGER];

        if (dashboardItemId in this._orderingValuesPerItem) {
            if (columnName in this._orderingValuesPerItem[dashboardItemId]) {
                const value = this._orderingValuesPerItem[dashboardItemId][columnName];
                if (value != null && Array.isArray(value)) {
                    return value;
                }
            }
            return listWithMinValue;
        }
        return listWithMinValue;
    }
}